/* eslint-disable react/prop-types */
import React, { useMemo } from "react"
import { currencyOperation, invoiceNumberFormat } from "./utils"

function TotalCostTable({ classes, data }) {
  const withComma = useMemo(() => ["JPY", "$"].includes(data.currency?.code), [
    data.currency,
  ])

  const subTotal = useMemo(() => {
    const { paymentPercentage, productDescriptions } = data
    let amount = 0
    if (!paymentPercentage) {
      amount = productDescriptions.reduce(
        (a, b) =>
          a + currencyOperation(+b.unitPrice, data.rateIn, data.currencyRate),
        0
      )
    } else {
      amount = productDescriptions.reduce(
        (a, b) =>
          a +
          currencyOperation(+b.unitPrice, data.rateIn, data.currencyRate) *
            (0 + paymentPercentage / 100),
        0
      )
    }
    if (withComma) return amount
    return Math.ceil(amount)
  }, [data, withComma])

  const otherTaxBase = React.useMemo(() => {
    if (!data.vat) return subTotal - data.discount
    return Math.round((11 / data.vat) * (subTotal - data.discount))
  }, [subTotal, data.discount, data.vat])

  const taxAmount = React.useMemo(() => {
    return otherTaxBase * (data.vat / 100)
  }, [data.vat, otherTaxBase])

  const totalCost = React.useMemo(() => {
    const totalPph = (subTotal - data.discount) * (data.pph23 / 100)

    return subTotal - data.discount + taxAmount - totalPph
  }, [data, subTotal, taxAmount])

  const currencyCode = useMemo(() => data.currency?.code, [data.currency?.code])

  return (
    <table className={classes.sectionTotalTable}>
      <tbody>
        <tr>
          <th>Subtotal</th>
          <th>{invoiceNumberFormat(subTotal, currencyCode)}</th>
        </tr>
        <tr>
          <th>Discount</th>
          <th>{invoiceNumberFormat(data.discount ?? 0, currencyCode)}</th>
        </tr>
        <tr>
          <th>Total After Discount</th>
          <th>
            {invoiceNumberFormat(subTotal - (data.discount ?? 0), currencyCode)}
          </th>
        </tr>
        {data?.vat ? (
          <tr>
            <th>Other Tax Base</th>
            <th>{invoiceNumberFormat(otherTaxBase, currencyCode)}</th>
          </tr>
        ) : null}
        <tr>
          <th>VAT ({data.vat ?? 0}%)</th>
          <th>{invoiceNumberFormat(Math.round(taxAmount), currencyCode)}</th>
        </tr>
        <tr>
          <th>Pph23 ({data.pph23 ?? 0}%)</th>
          <th>
            {invoiceNumberFormat(
              Math.ceil(
                (subTotal - data.discount) * (0 + data?.pph23 / 100 ?? 0)
              ),
              currencyCode
            )}
          </th>
        </tr>

        <tr>
          <th>Total</th>
          <th>
            {invoiceNumberFormat(
              withComma ? totalCost : Math.round(totalCost),
              currencyCode
            )}
          </th>
        </tr>
      </tbody>
    </table>
  )
}

export default TotalCostTable
